@for (address of addressInfo(); track address.addressId) {
    <ev-accordion class="accordion" [evStyle]="'blue-05-gradient'" [borderStyle]="'border-style-blue'" (toggled)="expanderClicked()">
        <div header class="accordion-header">
            <div class="title">
                {{address.streetName}} {{address.streetNumber}}
                @if (address.streetLetter) {
                    {{address.streetLetter}}
                }
                , {{address.postalCode}} {{address.postOfficeName}}
            </div>
        </div>

        <div body>
            <div class="address-details">
                <div class="column">
                    <div class="info-item">
                        <div>Adressetype</div>
                        <div>{{ address.addressType }}</div>
                    </div>
                    <div class="info-item">
                        <div>Alternativ adresse</div>
                        <div>{{ address.alternativeAddress }}</div>
                    </div>
                    <div class="info-item">
                        <div>Tetthet</div>
                        <div>{{ address.populationDensityCategory }}</div>
                    </div>
                    <div class="info-item last-left">
                        <div>Kirkesogn</div>
                        <div>{{ address.parish }}</div>
                    </div>
                </div>
                <div class="column">
                    <div class="info-item">
                        <div>Grunnkrets</div>
                        <div>{{ address.basicStatisticalUnitName }}</div>
                    </div>
                    <div class="info-item">
                        <div>Valgkrets</div>
                        <div>{{ address.electoralDistrict }}</div>
                    </div>
                    <div class="info-item last-right">
                        <div>Skolekrets</div>
                        <div>{{ address.schoolDistrict }}</div>
                    </div>
                </div>
            </div>
        </div>
    </ev-accordion>
}

